export default "https://cdn.questicon.mathletics.com/assets/audio/correctAnswerScreen-809aca559021c72b6b7c27d6140c95eb.mp3";